module.exports = __webpack_public_path__ + "img/icon-sistecredito.c70090ed.svg";